// Post-migration, Jira tickets are split across two Atlassian Cloud sites:
// DEVSD-prefixed tickets live on the ITSM/Service Desk site, everything else
// (CHG, ARAPS, ...) is on the main Teladoc Health site. The old on-prem
// jira.teladoc.net has been retired.
export function jiraUrlFor(ticket: string): string {
    const base = ticket.toUpperCase().startsWith('DEVSD-')
        ? 'https://itsm-teladochealth.atlassian.net'
        : 'https://teladochealth.atlassian.net';
    return `${base}/browse/${ticket}`;
}
